const postActionsStore = {
  toastr: 'Added action',
  toastr1: 'Action has been successfully added'
};

export default postActionsStore;
